const SESSION_KEY = 'alterme_session_token';

export interface AuthUser {
  id: string;
  email: string;
  displayName: string | null;
  role: 'user' | 'super_admin';
  lastLogin: string | null;
}

export function getSessionToken(): string | null {
  return localStorage.getItem(SESSION_KEY);
}

export function setSessionToken(token: string): void {
  localStorage.setItem(SESSION_KEY, token);
}

export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY);
}

export async function fetchCurrentUser(): Promise<AuthUser | null> {
  const token = getSessionToken();
  if (!token) return null;
  try {
    const res = await fetch('/api/auth/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) { clearSession(); return null; }
    return res.json();
  } catch {
    return null;
  }
}

export async function requestMagicLink(email: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const res = await fetch('/api/auth/request-link', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    if (!res.ok) return { ok: false, error: data.error || 'Request failed' };
    return { ok: true };
  } catch {
    return { ok: false, error: 'Network error. Please try again.' };
  }
}

export async function logout(): Promise<void> {
  const token = getSessionToken();
  if (token) {
    await fetch('/api/auth/logout', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  }
  clearSession();
}
